'use strict';

angular.module('mandaeApp')
    .controller('templateColaboradorCtrl', function ($scope, $log, $stateParams, Historico) {
        Historico.getSituacaoOs($stateParams.idPedido)
            .then(function (data) {
                $scope.colaborador = data.colaborador;
            })
            .catch($scope.tratarErrosBackEnd);
    });